import styles from "./TokenomicsHeader.module.css";

export const TokenomicsHeader = () => {
  return (
    <>
      <div className={styles.tokenomics_header}></div>
    </>
  );
};
